export default "__VITE_ASSET__DM8gw8Ew__"